import { render, staticRenderFns } from "./GroupInfo.vue?vue&type=template&id=700d70da&scoped=true&"
import script from "./GroupInfo.vue?vue&type=script&lang=js&"
export * from "./GroupInfo.vue?vue&type=script&lang=js&"
import style0 from "./GroupInfo.vue?vue&type=style&index=0&id=700d70da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700d70da",
  null
  
)

export default component.exports